import { render } from "./MainBar.vue?vue&type=template&id=513bb988&scoped=true"
import script from "./MainBar.vue?vue&type=script&lang=js"
export * from "./MainBar.vue?vue&type=script&lang=js"

import "./MainBar.vue?vue&type=style&index=0&id=513bb988&lang=scss&scoped=true"
import "./MainBar.vue?vue&type=style&index=1&id=513bb988&lang=scss"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513bb988"]])

export default __exports__